import styled from "styled-components";
import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";

export const Container = styled.div<{ grayBackground?: boolean }>(({ theme, grayBackground }) => ({
    display: "flex",
    width: "100%",
    height: "100%",
    background: grayBackground
        ? theme.colors[theme.colorMode].background_Secondary
        : theme.colors[theme.colorMode].background_Primary,
}));

export const ContainerButton = styled(Button)<{ grayBackground?: boolean; marginTop?: number }>(
    ({ theme, grayBackground, marginTop }) => ({
        borderRadius: 0,
        border: "none",
        outline: "none",
        textAlign: "left",
        WebkitAppearance: "none",
        margin: 0,
        padding: theme.spacing.medium,
        height: "100%",
        minWidth: "20px",
        background: grayBackground
            ? theme.colors[theme.colorMode].background_Secondary
            : theme.colors[theme.colorMode].background_Primary,
        marginTop: marginTop !== undefined ? `${marginTop}px` : theme.spacing.xxxSmall,
    }),
);

export const ContainerContent = styled.div<{ grayBackground?: boolean }>(({ theme, grayBackground }) => ({
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    flex: 1,
    background: grayBackground
        ? theme.colors[theme.colorMode].background_Secondary
        : theme.colors[theme.colorMode].background_Primary,
}));
